
function format_erc20_amount(amount, symbol, decimals, show_decimals = 2) {
    return (amount / Math.pow(10, decimals)).toFixed(show_decimals) + " " + symbol;
}

export { format_erc20_amount };